import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { GoOrganization } from "react-icons/go";
import { FaFolderPlus, FaWrench, FaArchive, FaUserCog, FaUserGraduate, FaFileAlt, FaCampground, FaCommentDollar } from "react-icons/fa";
import { FcBullish } from "react-icons/fc";
import { VscExclude } from "react-icons/vsc";
import { TfiLayoutGrid2Alt } from "react-icons/tfi";
import { TbAppsFilled, TbCategoryFilled } from "react-icons/tb";
import { RiCurrencyFill } from "react-icons/ri";
import { BiLogoBlogger } from "react-icons/bi";
import { FiFolderPlus } from "react-icons/fi";
import { CgCalendarDates } from "react-icons/cg";
import { MdBackup, MdFolderZip,  MdMedicalServices, MdOutline3P, MdAssessment, MdEmail } from "react-icons/md";
import {  NavLink } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import SidebarMenu from "./SidebarMenu";
import { AuthRole } from "../services/AuthRole";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { BiBold, BiListPlus, BiSolidGridAlt } from "react-icons/bi";
import "./Sidebar.css";


const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [sidebarWidth, setSidebarWidth] = useState(250);
  const [isDragging, setIsDragging] = useState(false);
  const isResizing = useRef(false);

  const userId = localStorage.getItem('user_id');
  const isAdmin = localStorage.getItem('isAdmin');

  const routes = useMemo(() => [

    {
      path: "/",
      name: "Dashboard",
      visible: AuthRole.getRolePermission('default_dashbord'),
      icon: <TbAppsFilled />,
    },
    {
      name: "Vision & Strategic Plan",
      visible: AuthRole.getRolePermissionForParent(["business_core", "accountability_chart", "esr_dashboard"]),
      icon: <BiSolidGridAlt />,
      exact: true,
      subRoutes: [
        {
          path: "/business-core",
          name: "Business Core",
          visible: AuthRole.getRolePermission('business_core'),
          icon: <BiBold />,
        },
        {
          path: "/accountability-chart",
          name: "Organisational Chart",
          visible: AuthRole.getRolePermission('accountability_chart'),
          icon: <BiListPlus />,
        },
        {
          path: "/esr-dashboard",
          name: "ESR Dashboard",
          visible: AuthRole.getRolePermission('esr_dashboard'),
          icon: <TbAppsFilled />,
        },
  
      ],
    },
  
    {
      name: "Sales & Marketing",
      icon: <i className='bx bx-line-chart'></i>,
      visible: AuthRole.getRolePermissionForParent(["lead_tracker_Dashbord", "lead_tracker_MarketingandSales", "lead_tracker_Actives", "lead_tracker_Hold", "lead_tracker_LeadsAll"]),
      exact: true,
      subRoutes: [
        {
          path: "/lead-tracker-dashboard",
          name: "Dashboard",
          visible: AuthRole.getRolePermission('lead_tracker_Dashbord'),
          icon: <TfiLayoutGrid2Alt />,
        },
        {
          path: "/marketing",
          name: "Marketing",
          visible: AuthRole.getRolePermission('lead_tracker_MarketingandSales'),
          icon: <FcBullish />,
        },
  
        {
          path: "/leads",
          name: "CRM",
          visible: AuthRole.getRolePermission('lead_tracker_LeadsAll'),
          icon: <FaCommentDollar />,
        },
      ],
    },
    {
      name: "Construction Operations",
      visible: AuthRole.getRolePermissionForParent(["Production_Dashbord", "Completed_Jobs","Production_Project","ProjectManager_Dashbord", "ProjectManager_History", "cost_per_sf", 'Archive_Performance_Huddle']),
      icon: <TbAppsFilled />,
      exact: true,
      subRoutes: [
        {
          name: "Production",
          visible: AuthRole.getRolePermissionForParent(["Production_Dashbord", "Production_Project","Completed_Jobs", "Projects_Archived"]),
          icon: <MdFolderZip />,
          exact: true,
          subRoutes: [
            {
              path: "/production-schedule",
              name: "Production Schedule",
              visible: AuthRole.getRolePermission('Production_Dashbord'),
              icon: <TbAppsFilled />,
            },
            {
              path: "/completed-jobs",
              name: "Warranty Started",
              visible: AuthRole.getRolePermission('Completed_Jobs'),
              icon: <TbAppsFilled />,
            },
            {
              path: "/projects-archived",
              name: "Projects Archived",
              visible: AuthRole.getRolePermission('Projects_Archived'),
              icon: <TbAppsFilled />,
            },
      
            // {
            //   path: "/project",
            //   name: "Projects",
            //   visible: AuthRole.getRolePermission('Production_Project'),
            //   icon: <FaFolderPlus />,
            // },
      
          ],
        },
        {
          name: "My Playbooks",
          icon: <MdOutline3P />,
          visible: AuthRole.getRolePermissionForParent(["ProjectManager_Dashbord", "ProjectManager_History", "cost_per_sf",]),
          subRoutes: [
            {
              path: "/playbooks",
              name: "Playbooks",
              visible: AuthRole.getRolePermission('ProjectManager_Dashbord'),
              icon: <FiFolderPlus />,
            },
            // {
            //   path: "/archive-history",
            //   name: "History",
            //   visible: AuthRole.getRolePermission('ProjectManager_History'),
            //   icon: <FiFolderPlus />,
            // },
            {
              path: "/client-update-history",
              name: "Client Update Timestamp",
              visible: AuthRole.getRolePermission('admin'),
              icon: <FiFolderPlus />,
            },
            // {
            //   path: "/archive-history",
            //   name: "Archive History",
            //   visible: AuthRole.getRolePermission('ProjectManager_History'),
            //   // visible: AuthRole.getRolePermission('admin'),
            //   icon: <FiFolderPlus />,
            // },
      
          ],
        },
      ]
    },
    // {
    //   name: "Production",
    //   visible: AuthRole.getRolePermissionForParent(["Production_Dashbord", "Production_Project","Completed_Jobs"]),
    //   icon: <MdFolderZip />,
    //   exact: true,
    //   subRoutes: [
    //     {
    //       path: "/production-schedule",
    //       name: "Production Schedule",
    //       visible: AuthRole.getRolePermission('Production_Dashbord'),
    //       icon: <TbAppsFilled />,
    //     },
    //     {
    //       path: "/completed-jobs",
    //       name: "Completed Projects",
    //       visible: AuthRole.getRolePermission('Completed_Jobs'),
    //       icon: <TbAppsFilled />,
    //     },
  
    //     // {
    //     //   path: "/project",
    //     //   name: "Projects",
    //     //   visible: AuthRole.getRolePermission('Production_Project'),
    //     //   icon: <FaFolderPlus />,
    //     // },
  
    //   ],
    // },
    //* ----------Financials---------------------------------
    {
      name: "Financial Control",
      visible: AuthRole.getRolePermissionForParent(["Cashflow_PandLSummary", "Cashflow_PandLandCashflowProjection", "Cashflow_Cashflow", "Cashflow_Budget", "cost_per_sf", "labour-framing-calculator"]),
      icon: <RiCurrencyFill />,
      exact: true,
      subRoutes: [
        {
          path: "/summary",
          name: "Financial Summary",
          visible: AuthRole.getRolePermission('Cashflow_PandLSummary'),
          icon: <FaCampground />,
        },
        {
          path: "/projection",
          name: "Income Statement",
          visible: AuthRole.getRolePermission('Cashflow_PandLandCashflowProjection'),
          icon: <FaFileAlt />,
        },
        {
          path: "/cashflow",
          name: "Revenue Projections",
          visible: AuthRole.getRolePermission('Cashflow_Cashflow'),
          icon: <RiCurrencyFill />,
        },
        // {
        //   path: "/budget",
        //   name: "Overhead Budget",
        //   visible: AuthRole.getRolePermission('Cashflow_Budget'),
        //   icon: <i className='bx bx-user-plus'></i>,
        // },
        {
          path: "/cost-per-sf",
          name: "Cost Per SF",
          visible: AuthRole.getRolePermission('cost_per_sf'),
          icon: <FiFolderPlus />,
        },
        {
          path: "/labour-framing-calculator",
          name: "Labour Framing Calculator",
          visible: AuthRole.getRolePermission('labour_framing_calculator'),
          icon: <FiFolderPlus />,
        },
        {
          name: "Billable vs Unbillable",
          icon: <BiLogoBlogger />,
          visible: AuthRole.getRolePermissionForParent(["BillablevsUnbillable_Config", "BillablevsUnbillable_Year", "BillablevsUnbillable_Dashbord"]),
          exact: true,
          subRoutes: [
            {
              path: "/billable-Dashboard",
              name: "Pay Periods",
              visible: AuthRole.getRolePermission('BillablevsUnbillable_Dashbord'),
              icon: <TbCategoryFilled />,
            },
            {
              path: "/billable-year",
              name: "Annual Pay Periods" ,
              // name: "Year " + new Date().getFullYear(),
              visible: AuthRole.getRolePermission('BillablevsUnbillable_Year'),
              icon: <CgCalendarDates />,
            },
            {
              path: "/billable-config",
              name: "Config",
              visible: AuthRole.getRolePermission('BillablevsUnbillable_Config'),
              icon: <i className='bx bxs-cog'></i>,
            },
          ],
        },
        {
          name: "Project Creep",
          icon: <BiLogoBlogger />,
          visible: AuthRole.getRolePermissionForParent(["pre_con_creep", "construction_creep",]),
          exact: true,
          subRoutes: [
            {
              path: "/pre-con-creep",
              name: "Pre Con Creep",
              visible: AuthRole.getRolePermission('pre_con_creep'),
              icon: <TbAppsFilled />,
            },
            {
              path: "/construction-creep",
              name: "Construction Creep",
              visible: AuthRole.getRolePermission('construction_creep'),
              icon: <TbAppsFilled />,
            },
            {
              path: "/overall-creep",
              name: "Over All Creep",
              visible: AuthRole.getRolePermission('overall_creep'),
              icon: <TbAppsFilled />,
            },
  
          ],
        },
      ],
    },
    //! ----------Financials---------------------------------
  
    // {
    //   name: "Upload",
    //   icon: <MdBackup />,
    //   visible: AuthRole.getRolePermissionForParent(["Upload_PandlByJob", "Setting_Cashflow",]),
    //   exact: true,
    //   subRoutes: [
    //     {
    //       path: "/actuals",
    //       name: "P&L By Job",
    //       visible: AuthRole.getRolePermission('Upload_PandlByJob'),
    //       icon: <MdMedicalServices />,
    //     },
    //     {
    //       path: "/config",
    //       name: "P&L Config",
    //       visible: AuthRole.getRolePermission('Setting_Cashflow'),
    //       icon: <VscExclude />,
    //     }, 
  
    //   ],
    // },
   //* --------Human Resources-----------
    {
      name: "Performance & Development",
      visible: AuthRole.getRolePermissionForParent(["quarterly_huddle_conversation", "quarterly_huddle_conversation_history","performance_review", "performance_review_history", "performance_huddle_dashboard", "ProjectManager_PerformancePoint", "vp_sales__and_marketing_dashbord", "vp_sales__and_marketing", "financial_controller_dashbord", "financial_controller", "accounting_dashbord", "accounting"]),
      icon: <TbAppsFilled />,
      exact: true,
      subRoutes: [
        {
          name: "Performance Huddle",
          icon: <MdOutline3P />,
          visible: AuthRole.getRolePermissionForParent(["performance_huddle_dashboard", "ProjectManager_PerformancePoint", "vp_sales__and_marketing_dashbord", "vp_sales__and_marketing", "financial_controller_dashbord", "financial_controller", "accounting_dashbord", "accounting",]),
          exact: true,
          subRoutes: [
            {
              path: "/performance-huddle-dashboard",
              name: "All Performance Huddle ",
              visible: isAdmin === "Y" && AuthRole.getRolePermission('performance_huddle_dashboard'),
              icon: <TbCategoryFilled />, 
            },
            {
              path: "/performance-huddle",
              name: "My Performance Huddle",
              visible: (() => {
                if (isAdmin === "Y") return false;
                const permissionRole = localStorage.getItem('permission_role') || '';
                const excluded = ["vp_sales__and_marketing", "financial_controller", "accounting"];
                return AuthRole.getRolePermission('ProjectManager_PerformancePoint') && !excluded.some(role => permissionRole.includes(role));
              })(),
              icon: <TbCategoryFilled />, 
            },
            {
              path: "/vp-sales-and-marketing",
              name: "My Performance Huddle", //name: "Sales ",
              visible: isAdmin === "N" && AuthRole.getRolePermissionY('vp_sales__and_marketing'),
              icon: <FiFolderPlus />, 
            },
            {
              path: "/financial-controller",
              name: "My Performance Huddle", //name: "Financial Controller",
              visible: isAdmin === "N" && AuthRole.getRolePermissionY("financial_controller"),
              icon: <FiFolderPlus />, 
            },
            {
              path: "/accounting",
              name: "My Performance Huddle", //name: "Accounting",
              visible: isAdmin === "N" && AuthRole.getRolePermissionY("accounting"),
              icon: <FiFolderPlus />, 
            },
          ],
        },
        {
          name: "Huddle Conversation",
          icon: <MdOutline3P />,
          visible: AuthRole.getRolePermissionForParent(["quarterly_huddle_conversation", "quarterly_huddle_conversation_history",]),
          exact: true,
          subRoutes: [
      
            {
              path: "/quarterly-huddle-conversation",
              name: "Quarterly Huddle Conversation",
              visible: AuthRole.getRolePermission('quarterly_huddle_conversation'),
              icon: <TbAppsFilled />,
            },
            {
              path: "/quarterly-huddle-conversation-history",
              name: "Huddle Conversation History",
              visible: AuthRole.getRolePermission('quarterly_huddle_conversation_history'),
              icon: <TbAppsFilled />,
            },
            {
              path: "/team-score",
              name: "Team Score",
              visible: AuthRole.getRolePermissionHR('admin'),
              icon: <MdAssessment />,
            },
          ],
        },
        {
          name: "Annual Huddle",
          icon: <MdOutline3P />,
          visible: AuthRole.getRolePermissionForParent(["performance_review", "performance_review_history",]),
          exact: true,
          subRoutes: [
      
            {
              path: "/performance-review",
              name: "My Annual Huddle",
              visible: AuthRole.getRolePermission('performance_review'),
              icon: <TbAppsFilled />,
            },
            {
              path: "/performance-review-history",
              name: "All Annual Huddle",
              visible: AuthRole.getRolePermission('performance_review_history'),
              icon: <TbAppsFilled />,
            },
            
          ],
        },
      ]
    },
    // {
    //   name: "Huddle Conversation",
    //   icon: <MdOutline3P />,
    //   visible: AuthRole.getRolePermissionForParent(["quarterly_huddle_conversation", "quarterly_huddle_conversation_history",]),
    //   exact: true,
    //   subRoutes: [
  
    //     {
    //       path: "/quarterly-huddle-conversation",
    //       name: "Quarterly Huddle Conversation",
    //       visible: AuthRole.getRolePermission('quarterly_huddle_conversation'),
    //       icon: <TbAppsFilled />,
    //     },
    //     {
    //       path: "/quarterly-huddle-conversation-history",
    //       name: "Huddle Conversation History",
    //       visible: AuthRole.getRolePermission('quarterly_huddle_conversation_history'),
    //       icon: <TbAppsFilled />,
    //     },
    //     {
    //       path: "/team-score",
    //       name: "Team Score",
    //       visible: AuthRole.getRolePermissionHR('admin'),
    //       icon: <GrBladesVertical />,
    //     },
    //   ],
    // },
    // {
    //   name: "Annual Performance Review",
    //   icon: <MdOutline3P />,
    //   visible: AuthRole.getRolePermissionForParent(["performance_review", "performance_review_history",]),
    //   exact: true,
    //   subRoutes: [
  
    //     {
    //       path: "/performance-review",
    //       name: "My Performance Review",
    //       visible: AuthRole.getRolePermission('performance_review'),
    //       icon: <TbAppsFilled />,
    //     },
    //     {
    //       path: "/performance-review-history",
    //       name: "Performance Review History",
    //       visible: AuthRole.getRolePermission('performance_review_history'),
    //       icon: <TbAppsFilled />,
    //     },
        
    //   ],
    // },
    // {
    //   name: "Performance Huddle",
    //   icon: <MdOutline3P />,
    //   visible: AuthRole.getRolePermissionForParent(["performance_huddle_dashboard", "ProjectManager_PerformancePoint", "vp_sales__and_marketing_dashbord", "vp_sales__and_marketing", "financial_controller_dashbord", "financial_controller", "accounting_dashbord", "accounting",]),
    //   exact: true,
    //   subRoutes: [
    //     {
    //       path: "/performance-huddle-dashboard",
    //       name: "All Performance Huddle ",
    //       visible: AuthRole.getRolePermission('performance_huddle_dashboard'),
    //       icon: <TbCategoryFilled />,
    //     },
    //     {
    //       path: "/performance-huddle",
    //       name: "My Performance Huddle",
    //       visible: AuthRole.getRolePermission('ProjectManager_PerformancePoint'),
    //       icon: <TbCategoryFilled />,
    //     },
  
    //     {
    //       path: "/vp-sales-and-marketing",
    //       name: "Sales ",
    //       visible: AuthRole.getRolePermissionY('vp_sales__and_marketing'),
    //       icon: <FiFolderPlus />,
    //     },
  
    //     {
    //       path: "/financial-controller",
    //       name: "Financial Controller",
    //       visible: userId === '20' || AuthRole.getRolePermissionY("financial_controller"),
    //       icon: <FiFolderPlus />,
    //     },
  
    //     {
    //       path: "/accounting",
    //       name: "Accounting",
    //       visible: userId === '33' || AuthRole.getRolePermissionY("accounting"),
    //       icon: <FiFolderPlus />,
    //     },
    //   ],
    // },
    // {
    //   name: "My Playbooks",
    //   icon: <MdOutline3P />,
    //   visible: AuthRole.getRolePermissionForParent(["ProjectManager_Dashbord", "ProjectManager_History", "cost_per_sf",]),
    //   subRoutes: [
    //     {
    //       path: "/playbooks",
    //       name: "Playbooks",
    //       visible: AuthRole.getRolePermission('ProjectManager_Dashbord'),
    //       icon: <FiFolderPlus />,
    //     },
    //     // {
    //     //   path: "/archive-history",
    //     //   name: "History",
    //     //   visible: AuthRole.getRolePermission('ProjectManager_History'),
    //     //   icon: <FiFolderPlus />,
    //     // },
  
    //   ],
    // },
  
    {
      path: "/best-practices",
      name: "Best Practices for Using Builder Playbook",
      icon: <BiLogoBlogger />,
      visible: true,
    },
    {
      path: "/setting",
      name: "Settings",
      icon: <FaWrench />,
      visible: AuthRole.getRolePermissionForParent(["Setting_Cashflow", "Setting_ProjectType", "Setting_UserRole", "Setting_ProjectManager", "Setting_organization", "Upload_PandlByJob", "Setting_Log"]),
      exact: true,
      subRoutes: [
        // {
        //   path: "/config",
        //   name: "Config",
        //   visible: AuthRole.getRolePermission('Setting_Cashflow'),
        //   icon: <VscExclude />,
        // },  
        {
          path: "/log",
          name: "Log History",
          visible: AuthRole.getRolePermission('Setting_Log'),
          icon: <GoOrganization />,
        },
        {
          path: "/organization",
          name: "Organization",
          // visible: AuthRole.getRolePermissionOnlyShowLidaHomes(true),
          visible: AuthRole.getRolePermission('Setting_organization'),
          icon: <GoOrganization />,
        },
        // {
        //   path: "/projecttype",
        //   name: "Project Type",
        //   visible: AuthRole.getRolePermission('Setting_ProjectType'),
        //   icon: <FaArchive />,
        // },
        {
          path: "/usermodule",
          name: "Manage Role",
          visible: AuthRole.getRolePermission('Setting_UserRole'),
          icon: <FaUserGraduate />,
        },
        {
          path: "/users",
          name: "Manage Users",
          visible: AuthRole.getRolePermission('Setting_ProjectManager'),
          icon: <FaUserCog />,
        },
        {
          path: "/lead-source-config",
          name: "Lead Source Config",
          visible: AuthRole.getRolePermission('Setting_LeadSourceConfig'),
          // visible: AuthRole.getRolePermission('Setting_ProjectManager'),
          icon: <FaUserCog />,
        },
        {
          name: "Upload",
          icon: <MdBackup />,
          visible: AuthRole.getRolePermissionForParent(["Upload_PandlByJob", "Setting_Cashflow",]),
          exact: true,
          subRoutes: [
            {
              path: "/actuals",
              name: "Actual",
              visible: AuthRole.getRolePermission('Upload_PandlByJob'),
              icon: <MdMedicalServices />,
            },
            {
              path: "/config",
              name: "Config",
              visible: AuthRole.getRolePermission('Setting_Cashflow'),
              icon: <VscExclude />,
            },
  
          ],
        },
      ],
    },
    {
      path: "/email-test",
      name: "Email Test",
      icon: <MdEmail />,
      visible: true,
    },
    // {
    //   name: "Help",
    //   icon: <MdHelpCenter />,
    //   // visible: AuthRole.getRolePermissionForParent(["Upload_PandlByJob", "Setting_Cashflow",]),
    //   exact: true,
    //   subRoutes: [
    //     {
    //       path: "/help-list",
    //       name: "Help List",
    //       visible: true,
    //       icon: <MdHelpCenter size={20} />,
    //     },
    //     {
    //       path: "/help",
    //       name: "Help",
    //       visible: true,
    //       icon: <MdHelpCenter size={20} />,
    //     },
  
    //   ],
    // },
  
  ], [userId, isAdmin]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const startResizing = useCallback((mouseDownEvent) => {
    if(!isOpen) return; // Prevent resizing when closed
    isResizing.current = true;
    setIsDragging(true);
    document.body.style.cursor = 'col-resize';
  }, [isOpen]);

  const stopResizing = useCallback(() => {
    isResizing.current = false;
    setIsDragging(false);
    document.body.style.cursor = 'default';
  }, []);

  const resize = useCallback((mouseMoveEvent) => {
    if (isResizing.current) {
      const newWidth = mouseMoveEvent.clientX;
      if (newWidth >= 200 && newWidth <= 600) {
        setSidebarWidth(newWidth);
      }
    }
  }, []);

  useEffect(() => {
    window.addEventListener("mousemove", resize);
    window.addEventListener("mouseup", stopResizing);
    return () => {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    };
  }, [resize, stopResizing]);

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.5,
      },
    },
  };

  const [organizationName, setOrganizationName] = useState('Lida Construction');
  const [organizationImage, setOrganizationImage] = useState('');

  useEffect(() => {
    setOrganizationName(localStorage.getItem('organizationName'))
    setOrganizationImage(localStorage.getItem('organizationLogo'))

  }, []);

  return (
    <div className="main-container">

      <motion.div
        animate={{
          width: isOpen ? `${sidebarWidth}px` : "50px",
          transition: {
            duration: isDragging ? 0 : 0.5,
            type: isDragging ? "tween" : "spring",
          },
        }}
        className={`sidebar `}
      >
        <div
          className="sidebar-resizer"
          onMouseDown={startResizing}
        />

        <div className="top_section">
          <AnimatePresence>
            {isOpen && (
              <motion.h1
                variants={showAnimation}
                initial="hidden"
                animate="show"
                exit="hidden"
                className="logo"
              >
                {organizationImage == '' ? <a href="/">
                  {/* <img className="imglogo" src="/download.png" alt="Builder Tracker" /> */}
                  <span className="alt-text"><img className="imglogo" src="/download.png" alt={organizationName} /></span>
                </a> : <a href="/"><img className="imglogo" src={`${organizationImage}`} alt={organizationName} /></a>}

              </motion.h1>
            )}
          </AnimatePresence>

          <div className="bars">
            {isOpen ? <FaAngleLeft onClick={toggle} /> : <FaAngleRight onClick={toggle} />}

          </div>
        </div>


        <section className="routes">


          {routes.map((route, index) => {
            if (route.visible == false) {
              return null;
            }

            if (route.subRoutes) {
              return (
                <SidebarMenu
                  key={index}
                  setIsOpen={setIsOpen}
                  route={route}
                  showAnimation={showAnimation}
                  isOpen={isOpen}
                />
              );
            }

            return (
              <NavLink
                to={route.path}
                key={index}
                className="menu-item"
                activeclassname="active"
                title={route.name} // Add title attribute for native tooltip
              >
                <div className="icon">{route.icon}</div>
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      variants={showAnimation}
                      initial="hidden"
                      animate="show"
                      exit="hidden"
                      className="link_text"
                    >
                      {route.name}
                    </motion.div>
                  )}
                </AnimatePresence>
              </NavLink>
            );
          })}
        </section>

        <div className="help-icon  flex justify-content-end align-items-center">
          {/* <div className="ml-auto">
            <Link to="/help">
              <MdHelpCenter size={40} title="Help" />
            </Link>
          </div> */}
        </div>

        <div className="footer">
          <AnimatePresence>
            {isOpen && (
              <motion.div
                variants={showAnimation}
                initial="hidden"
                animate="show"
                exit="hidden"
                className="footer_text"
              >
                &copy; {new Date().getFullYear()} Builderplaybook Inc. All rights reserved.
                <br />
                <span
                  style={{
                    fontSize: "12px",
                    color: "#bbb",
                    display: "block",
                  }}
                >
                  Last Update: {process.env.REACT_APP_BUILD_DATE || "Unknown"}
                </span>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </motion.div>

    </div>
  );
};

export default Sidebar;